  <template>
    <div>
      <page-title icon="fa fa-leaf" main="Safras" sub="Ano Safra" :help="true" titleHelp="Página responsável pela listagem de Anos Safras"
      content="Para alteração basta ir com o mouse em ações e clicar em Editar.
  Para criação pressione o botão no canto superior direito 'Novo ano SAFRA'">
        <template v-slot:actions>
          <base-button
            v-if="$can('create', 'anosafra')"
            @click="newAnosafra"
            type="neutral"
            class="ml-3"
            size="sm"
            >Novo Ano Safra</base-button
          >
        </template>
      </page-title>
      <div class="card mt-2" style="padding: 1rem">
        <!-- <label class="form-control-label">Ano Safra</label>
        <multiselect
          v-model="filter.anosafra"
          :options="optionsAnosafras"
          label="descricao"
          track-by="descricao"
          :allow-empty="true"
          select-label=""
          deselect-label=""
          placeholder="Selecionar Ano Safra"
          >
        </multiselect> -->
        <anosafra-multiselect
          v-model="filter.anosafra"
          label="Ano Safra"
        />
        <div class="row justify-content-end" style="padding: 1rem">
          <base-button
            @click="clearFilters"
            color="green"
            type="neutral"
            class="mr-3"
          >Limpar Filtros
          </base-button>
          <base-button
            @click="search"
            type="primary"
          >
            <i class="fas fa-filter"></i>Filtrar
          </base-button>
        </div>

        <!-- Edition / Creation Modal -->
        <modal :show.sync="modals.formAnosafra" id="anosafra">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">{{ anosafra.id ? 'Editar' : 'Novo' }} Ano Safra</h5>
          </template>
          <form role="form" @submit.prevent="saveAnosafra">
            <anosafra-form v-model="anosafra" :errors="errors" />
          </form>
          <template slot="footer">
            <base-button type="secondary" @click="modals.formAnosafra = false">Fechar</base-button>
            <base-button type="success" v-if="anosafra.addPercentage" @click="editPercentages(anosafra)" :disabled="savingAnoSafra" v-loading="savingAnoSafra" >Continuar</base-button>
            <base-button type="success" v-else @click="saveAnosafra" :disabled="savingAnoSafra" v-loading="savingAnoSafra" >Salvar</base-button>
          </template>
        </modal>

        <!-- update client wallet -->
        <modal 
          :show.sync="modals.updateWallet" 
          @close="closeUpdateWallet"
          :body-classes="'permit-overflow'"
        >
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Atualizar Carteira</h5>
          </template>
          <div>
            <user-multiselect 
              ref="salesmanMultiselect"
              v-model="filter.salesman"
              :name-only="true"
              :user-type="'salesman'"
              :filter="walletUpdateFilter"
              label="Vendedor"
              :required="true"
              :multiple="true"
              :close-on-select="false"
            />
          </div>
          <span class="text-danger" v-if="selectedAnosafra.id == this.$store.state.currentAnosafra.id">Não é possível atualizar carteira de vendedores para ano safra vigênte</span>
          <span class="text-danger" v-if="warningVisible">Campo vendedor não pode ficar em branco</span>

          <template slot="footer">
            <base-button type="secondary" @click="closeUpdateWallet">Fechar</base-button>
            <base-button 
              type="success" 
              @click="clientWallet"
              :disabled="selectedAnosafra.id == this.$store.state.currentAnosafra.id"
              v-loading="loadingClientWallet"
            >
              Salvar
            </base-button>
          </template>
        </modal>

        <!-- Copy Percentage Modal -->
        <modal :show.sync="modals.percentages" size="lg" id="anosafra-edit-percentages">
          <template slot="header">
            <h5 class="modal-title">Porcentagens</h5>
          </template>
          <form role="form" @submit.prevent="saveAnosafra">
            <anosafra-percentages-form 
              v-model="anosafra" 
              ref="anosafraComponent" 
              :errors="errors" 
              :message="message"
              @update-validate-button="validateVisualizeButton = $event"
            />
          </form>
          <template slot="footer">
            <base-button type="info" :disabled="!validateVisualizeButton" @click="compareGoalsPercentages" v-if="anosafra.copy_volume || anosafra.copy_strategic_volume">Visualizar</base-button>
            <base-button type="secondary" @click="modals.percentages = false">Fechar</base-button>
            <base-button type="success" @click="saveAnosafraPercentages" :disabled="savingAnoSafra || !validateVisualizeButton" v-loading="savingAnoSafra">Salvar</base-button>
          </template>
        </modal>

        <!-- Compare Percentage Goals Modal -->
        <modal 
          :show.sync="modals.comparison" 
          size="lg" 
          id="anosafra-comparison-goals"
        >
          <template slot="header">
            <h5 class="modal-title">Porcentagens</h5>
          </template>
          <div class="row">
            <div :class="{'col-12 col-md-6': hasBothCards, 'col-6 offset-3': !hasBothCards}">
              <total-values-card 
                v-if="anosafra.copy_volume" 
                :total-values="adjustedFinancialGoal" 
                title="META FINANCEIRA" 
                :loading="this.loadingGoals" 
                error="Não existem metas fincanceiras cadastradas nesse ano safra"
              />
            </div>
            <div :class="{'col-12 col-md-6': hasBothCards, 'col-6 offset-3': !hasBothCards}">
              <div>
                <total-values-card 
                  v-if="anosafra.copy_strategic_volume" 
                  :total-values="adjustedStrategicGoal" 
                  title="META ESTRATÉGICA" 
                  :loading="this.loadingGoals"
                  error="Não existem metas estratégicas cadastradas nesse ano safra"
                />
              </div>
            </div>
          </div>
          <template slot="footer">
            <base-button type="success"   @click="saveAnosafraPercentages" :disabled="savingAnoSafra" v-loading="savingAnoSafra">Salvar</base-button>
            <base-button type="secundary" @click="modals.comparison = false">Fechar</base-button>
          </template>
        </modal>

        <!-- Anosafra list -->
        <div class="border-0 card-header">
          <h3 class="mb-0">Ano Safra Cadastrados:</h3>
        </div>

        <el-table
          v-loading="isLoading"
          :data="anosafras"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          style="width: 100%;"
        >
          <el-table-column label="Status" prop="is_open" min-width="140px" v-slot="{ row }" sortable>
            <badge class="badge-dot mr-4" type v-if="row.is_open">
              <i class="bg-success"></i> Aberto
            </badge>
            <badge class="badge-dot mr-4" type v-else>
              <i class="bg-danger"></i> Fechado
            </badge>
          </el-table-column>
          <el-table-column label="Status da cópia" prop="copy_status" min-width="170px" v-slot="{ row }">
            <badge class="badge-dot mr-4" type v-if="row.copy_status == 'to_do'">  Cópia pendente</badge>
            <badge class="badge-dot mr-4" type v-if="row.copy_status == 'doing'">  Copiando ano safra anterior</badge>
            <badge class="badge-dot mr-4" type v-if="row.copy_status == 'done'">   Cópia finalizada</badge>
            <badge class="badge-dot mr-4" type v-if="row.copy_status == 'failed'"> Falha ao copiar anosafra anterior</badge>
            <badge class="badge-dot mr-4" type v-if="row.copy_status == 'wont_copy'"> Cópia não realizada</badge>
          </el-table-column>
          <el-table-column label="Descrição" min-width="170px" prop="descricao" sortable/>
          <el-table-column label="Data de inicio" min-width="180px" prop="start_date" v-slot="{ row }" sortable >
            {{row.start_date | formatDate}}
          </el-table-column>
          <el-table-column min-width="180px" label="Data de fim" prop="end_date" v-slot="{ row }" sortable >
            {{row.end_date | formatDate}}
          </el-table-column>
          <el-table-column min-width="180px" label="Limite de Alteração" prop="update_end_date" v-slot="{ row }" sortable>
            {{row.update_end_date | formatDate}}
          </el-table-column>

          <el-table-column
            label="Ações"
            min-width="80px"
            prop="acoes"
            v-slot="{ row }"
            v-if="$can('update', 'anosafra') || $can('destroy', 'anosafra')"
          >
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer;"
            >
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" v-if="$can('update', 'anosafra')" href="#" @click="edit(row)">Editar</a>
                <a class="dropdown-item" href="#" @click="updateClientWallet(row)">Atualizar Carteira</a>
                <a class="dropdown-item" v-if="$can('update', 'anosafra')" href="#" @click="handleClickEditPercentages(row)">Porcentagens</a>
                <a class="dropdown-item" v-if="$can('destroy', 'anosafra')" href="#" @click="remove(row)">Excluir</a>
              </el-dropdown-menu>
            </el-dropdown>
          </el-table-column>
        </el-table>

        <div class="card-footer py-4 d-flex justify-content-end">
          <base-pagination
            v-on:input="changePage"
            v-model="paginated_data.current"
            :total="paginated_data.count"
            :perPage="paginated_data.per_page"
          >
          </base-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  import PageTitle from "@/layouts/PageTitle";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { Portuguese } from "flatpickr/dist/l10n/pt.js";
  import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
  import UserMultiselect from '@/components/Multiselect/user_multiselect.vue';
  import AnosafraMultiselect from '@/components/Multiselect/anosafra_multiselect.vue';
  import TotalValuesCard from '@/components/Goals/TotalValuesCard.vue';


  import swal from 'sweetalert2';
  import AnosafraForm from '../../components/Anosafra/AnosafraForm.vue'
  import AnosafraPercentagesForm from '../../components/Anosafra/AnosafraPercentagesForm.vue'
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    DatePicker,
  } from "element-ui";

  export default {
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      flatPicker,
      PageTitle,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [DatePicker.name]: DatePicker,
      Multiselect,
      AnosafraForm,
      AnosafraPercentagesForm,
      UserMultiselect,
      AnosafraMultiselect,
      TotalValuesCard,
    },
    data: () => ({
      filter: {
        salesman: [],
        anosafra: {}
      },
      modals: {
        formAnosafra: false,
        percentages: false,
        updateWallet: false,
        comparison: false,
      },
      paginated_data: {
        current: 1,
        count: 0,
        per_page: 20,
      },
      anosafra: {},
      item: "",
      anosafras: [],
      errors: {},
      suggestion: {},
      isLoading: false,
      savingAnoSafra: false,
      strategic_goal: {},
      financial_goal: {},
      realizedSales: {},
      isNewAnoSafra: false,
      config: {
        altInput: false,
        allowInput: true,
        dateFormat: "d/m/Y",
        locale: Portuguese,
      },
      optionsAnosafras: [],
      loadAnosafrasInterval: null,
      loadingClientWallet: false,
      loadingGoals: false,
      salesman_name: [],
      selectedAnosafra: {},
      walletUpdateFilter: {},
      warningVisible: false,
      message: "",
      goalsPercentageError: false,
      validateVisualizeButton: true
    }),
    mounted() {
      this.loadAnosafras()
    },
    methods: {
      search() {
        this.loadAnosafras();
      },
      changePage(page) {
        this.loadAnosafras();
      },
      newAnosafra() {
        this.product = {}
        this.anosafra = {samePercentageForAll: true}
        this.errors = {}
        this.modals.formAnosafra = true
        this.isNewAnoSafra = true
      },
      edit(anosafra) {
        this.anosafra = anosafra;
        this.errors = {}
        this.modals.formAnosafra = true;
      },
      updateClientWallet(anosafra){
        this.selectedAnosafra = anosafra;
        this.walletUpdateFilter = { ...this.filter, ...{ anosafra: anosafra } }
        this.modals.updateWallet = true;
      },
      closeUpdateWallet() {
        this.$refs.salesmanMultiselect.selectedUser = [];
        this.$refs.salesmanMultiselect.allSelected = false;
        this.$refs.salesmanMultiselect.allSelectedActive = false;
        this.$refs.salesmanMultiselect.pagination.page = 1;
        this.modals.updateWallet = false;
      },
      async clientWallet(){
        this.loadingClientWallet = true;
        const selectedAllUsers = this.$refs.salesmanMultiselect.allSelected && this.$refs.salesmanMultiselect.allSelectedActive
        const salesmen_ids = selectedAllUsers ? 
          'all' :
          this.filter.salesman && this.filter.salesman.length ? this.filter.salesman.map(el => el.id) : null
        
        if (!this.filter.salesman || this.filter.salesman.length === 0) {
          this.warningVisible = true; 
          return;
        }

        this.warningVisible = false;
        try {
          await this.$http.secured.get("/api/v1/update_client_wallet/", { 
            params: {
              anosafra_id: this.selectedAnosafra.id,
              salesmen_ids: salesmen_ids
            }
          })

          if (!this.filter.salesman.length) return;

          const salesmen = this.filter.salesman;
          const firstSalesman = salesmen[0].name;

          let successMessage;
          if (salesmen.length === 1) {
            successMessage = `A carteira de clientes do vendedor ${firstSalesman} foi atualizada com sucesso para o ano safra: ${this.selectedAnosafra.descricao}`;
          } else {
            successMessage = `A carteira de clientes dos vendedores ${firstSalesman} e demais vendedores selecionados foi atualizada com sucesso para o ano safra: ${this.selectedAnosafra.descricao}`;
          }

          this.$toasted.global.defaultSuccess({msg: successMessage});
          
        } catch (error) {
          console.error(["ListAnoSafra"]["clientWallet"], error);
        } finally {
          this.closeUpdateWallet()
          this.loadingClientWallet = false;
        }
      },
      editPercentages(anosafra) { 
        this.anosafra = anosafra;
        this.errors = {}
        this.modals.formAnosafra = false;
        this.modals.percentages = true;
      },
      handleClickEditPercentages(anosafra) {
        this.anosafra = anosafra
        this.editPercentages(anosafra)
        this.isNewAnoSafra = false
      },
      async getGoals() {
        this.loadingGoals = true
        
        if (this.isNewAnoSafra) {
          this.anosafra.id = this.$store.state.currentAnosafra.id
        }

        try {
          const response = await this.$http.secured.get("/api/v1/report/goals", {
            params: { "goal[anosafra_id]": this.anosafra.id }
          });

          const salesmanData = response.data;
          const goals          = {}
          const strategicGoals = {}

          salesmanData.forEach((salesmanData) => {
            salesmanData.goals.goal.forEach((group, index) => {
              const groupName = group.group

              goals[groupName] = (goals[groupName] || 0) + (group.sales_currency || 0);
              strategicGoals[groupName] =
                (strategicGoals[groupName] || 0) +
                (salesmanData.goals.strategic_goal[index].sales_currency || 0);
            });
          });
          
          const totalGoals = Object.values(goals).reduce((sum, value) => sum + value, 0); 
          const totalStrategicGoals = Object.values(strategicGoals).reduce((sum, value) => sum + value, 0);
            
          if (Object.keys(goals).length) this.financial_goal = { "TOTAL FINANCEIRA": totalGoals, ...goals };
          if (Object.keys(strategicGoals).length) this.strategic_goal = { "TOTAL ESTRATÉGICA": totalStrategicGoals, ...strategicGoals };

        } catch(error) {
          console.error("[ListAnoSafra] getGoals", error)
        }
        finally {
          this.loadingGoals = false
        }
      },
      async compareGoalsPercentages() {
        this.modals.comparison = true
        this.getGoals()
      },
      updateAnosafra() {
        this.savingAnoSafra = true
        this.$http.secured
          .put(`/api/v1/anosafras/${this.anosafra.id}`, this.anosafraToSave)
          .then((response) => {
            this.errors = {}
            this.savingAnoSafra = false
            this.response = response.data;
            this.modals.formAnosafra = false;
            this.modals.percentages = false;
            this.$toasted.global.defaultSuccess();
            this.loadAnosafras();
            this.anosafra = {};
            this.$store.dispatch('getCurrentAnosafra')
          })
          .catch((error) => {
            console.warn("Cannot update anosafra", error)
            if (error && error.response && error.response.data && error.response.data.errors){
              this.errors = error.response.data.errors
            }
            this.savingAnoSafra = false
          });
      },
      async loadAnosafras(args = {}) {
        if (!args.skipLoading) this.isLoading = true;

        const queryParams = {
          ...(this.filter.descricao && this.filter.descricao.length ? { descricao: this.filter.descricao } : {}),
          ...(this.filter.anosafra ? { id: this.filter.anosafra.id } : {}),
        }

        try {
          const response = await this.$http.secured.get(`/api/v1/anosafras`, {
            params: {
              page: this.paginated_data.current || 1,
              q: queryParams || null,
            },
          })
          this.anosafras = response.data.anosafras;
          if (!this.optionsAnosafras.length) this.optionsAnosafras = response.data.anosafras;
          this.count = response.data.count;
          this.limit = response.data.current;

          this.paginated_data.per_page = response.data.per_page || 20
          this.paginated_data.count    = response.data.count    || 0
          this.paginated_data.current  = response.data.current  || 1

          for (let anosafra = 0; anosafra < this.anosafras.length; anosafra++) {
            if (this.anosafras[anosafra].start_date) this.anosafras[anosafra].start_date = new Date(`${this.anosafras[anosafra].start_date}T00:00`)
            if (this.anosafras[anosafra].end_date) this.anosafras[anosafra].end_date = new Date(`${this.anosafras[anosafra].end_date}T00:00`)
            if (this.anosafras[anosafra].update_end_date) this.anosafras[anosafra].update_end_date = new Date(`${this.anosafras[anosafra].update_end_date}T00:00`)
            if (this.anosafras[anosafra].update_start_date) this.anosafras[anosafra].update_start_date = new Date(`${this.anosafras[anosafra].update_start_date}T00:00`)
          }
        } catch (error) {
          console.warn("Something went wrong", error)
        } finally {
          this.isLoading = false;
        }
      },
      async saveAnosafra() {
        if (!this.anosafra) return

        this.savingAnoSafra = true

        if (this.anosafra.id)  await this.updateAnosafra()
        if (!this.anosafra.id) await this.createAnosafra()

        this.savingAnoSafra = false
      },
      saveAnosafraPercentages() {
        this.anosafra.copy_status = 'to_do'
        this.anosafraComponent
        this.modals.percentages = false
        if (this.modals.comparison === true) this.modals.comparison = false
        this.savingAnoSafra = false
        this.saveAnosafra()
      },
      async createAnosafra() {
        try {
          const response = await this.$http.secured.post("/api/v1/anosafras", { anosafra: this.anosafraToSave })

          this.errors = {}
          this.savingAnoSafra = false
          this.anosafras.push(response.data);
          this.$toasted.global.defaultSuccess();
          this.modals.formAnosafra = false;
          this.loadAnosafras();
          this.anosafra = {};
          this.$store.dispatch('getCurrentAnosafra')

          if (response.data.copy_status == "wont_copy") {
            swal.fire({
              title: 'Para incluir porcentagens sobre os volumes das metas depois siga o fluxo abaixo:',
              text: "Safras > Ano Safra > Ações > Porcentagens",
              confirmButtonColor: '#2dce89',
              confirmButtonText: 'Entendi'
            })
          }
        } catch (error) {
          console.warn("Cannot save anosafra", error)
          if (error && error.response && error.response.data && error.response.data.errors){
            this.errors = error.response.data.errors
          }
        }
        this.savingAnoSafra = false
      },
      async remove(anosafra) {
        const fireResult = await swal.fire({
          title: 'Você tem certeza ?',
          text: "Podem existir metas vinculadas a este ano safra!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, quero remover!'
        })

        if(!fireResult.isConfirmed){
          // TODO: tratar erro
          return
        }

        try {
          await this.$http.secured.delete(`/api/v1/anosafras/${anosafra.id}`, anosafra)
          this.$toasted.global.defaultSuccess();
          this.loadAnosafras();
          this.anosafras.splice(this.anosafras.indexOf(this.anosafra), 1);
          this.$store.dispatch('getCurrentAnosafra')
        } catch (error) {
          // TODO: tratar erro
        }
      },
      formatDate(dateString){
        let dateParts = dateString.split('/');
        let finalString = '' + dateParts[1] + '-' + dateParts[0]
        if (dateParts.length > 2) finalString += '-' + dateParts[2]

        return finalString
      },
      clearFilters(){
        this.filter = null
        this.loadAnosafras()
      },
    },
    computed: {
      copy_volume_percentage() {
        if (!(this.anosafra && this.anosafra.copy_volume_percentage)) return 100

        return this.anosafra.copy_volume_strategy && this.anosafra.copy_volume_strategy.value == 'remove' ?
          100 - parseFloat(this.anosafra.copy_volume_percentage) :
          100 + parseFloat(this.anosafra.copy_volume_percentage)
      },
      copy_strategic_volume_percentage() {
        if (!(this.anosafra && this.anosafra.copy_strategic_volume_percentage)) return 100

        return this.anosafra.copy_strategic_volume_strategy && this.anosafra.copy_strategic_volume_strategy.value == 'remove' ?
          100 - parseFloat(this.anosafra.copy_strategic_volume_percentage) :
          100 + parseFloat(this.anosafra.copy_strategic_volume_percentage)
      },
      anosafraToSave() {
        let anosafra = this.anosafra
        let brand_copy_configurations_attributes;
        if (this.anosafra.samePercentageForAll) ({ brand_copy_configurations_attributes, ...anosafra } = anosafra);

        return {
          ...anosafra,
          copy_volume_percentage: this.copy_volume_percentage || 100,
          copy_strategic_volume_percentage: this.copy_strategic_volume_percentage || 100
        }
      },
      hasBothCards() {
        return this.anosafra.copy_volume && this.anosafra.copy_strategic_volume;
      },
      resetCards() {
        if (!this.modals.comparison) {
          this.strategic_goal = {}
          this.financial_goal = {}
        }       
      },
      adjustedFinancialGoal() {
        let adjustedGoal = {}
        
        if (
          !this.financial_goal ||
          !this.anosafra.copy_volume ||
          !this.anosafra.copy_volume_percentage ||
          this.anosafra.copy_volume_percentage < 1 ||
          this.anosafra.copy_volume_percentage > 100
        ) {
          return this.financial_goal;
        }

        const percentage = this.anosafra.copy_volume_percentage / 100;

        Object.entries(this.financial_goal).forEach(([key, value]) => {
          if (this.anosafra.copy_volume_strategy.value === 'add') {
            adjustedGoal[key] = value + value * percentage;
          } else if (this.anosafra.copy_volume_strategy.value === 'remove') {
            adjustedGoal[key] = value - value * percentage;
          }
        });
        
        return adjustedGoal;
      },
      adjustedStrategicGoal() {
        let adjustedGoal = {}

         if (
          !this.strategic_goal ||
          !this.anosafra.copy_strategic_volume ||
          !this.anosafra.copy_strategic_volume_percentage ||
          this.anosafra.copy_strategic_volume_percentage < 1 ||
          this.anosafra.copy_strategic_volume_percentage > 100
        ) {
          return this.strategic_goal;
        }

        const percentage = this.anosafra.copy_strategic_volume_percentage / 100;

         Object.entries(this.strategic_goal).forEach(([key, value]) => {
           adjustedGoal[key] = value - value * percentage;
         });

         return adjustedGoal
        },
    },
    watch: {
      'modals.comparison'() {
        if (!this.modals.comparison) {
          this.$nextTick(() => {
            this.resetCards;
        });
        }
      },
    }
  };
  </script>
  <style>
    .permit-overflow {
      overflow: visible !important;
    }
  </style>